import type { DeleteScimDomainMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteScimDomainDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

type DeleteScimDomainInput = { domain: string };

export const useDeleteScimDomain = createMutationHook({
  name: 'deleteScimDomain',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.scim.deleteDomain.mutationOptions({ onSuccess }),
  mapInput: (variables: DeleteScimDomainInput) => variables,
  invalidate: (trpc) => [trpc.frontend.scim.getConfig.queryKey()],
  mapResponse: (result: {
    updatedDomains: { domain: string; createdOn: string }[];
  }): DeleteScimDomainMutation => ({
    delete_scim_domain: {
      __typename: 'DeleteScimDomainOutput',
      updatedDomains: result.updatedDomains.map((d) => ({
        __typename: 'ScimDomainOutput',
        domain: d.domain,
        createdOn: d.createdOn,
      })),
    },
  }),
  graphqlDocument: DeleteScimDomainDocument,
  graphqlVariables: (variables: DeleteScimDomainInput) => ({ ...variables }),
  evictFields: ['getScimConfig'],
});
